import {Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[appBottomHint]'
})
export class BottomHintDirective {

  constructor(private elm: ElementRef) {
    this.elm.nativeElement.style.cssText  = "position: fixed; bottom: 10px; left: 10px; color: #fff; backgroundColor: rgba(0,0,0,.8); padding: 5px 10px;"

    // this.elm.style.opacity = 0;
  }

  public showHint(){
  }

}
